import React from 'react';
import PropTypes from 'prop-types';
import { times } from 'lodash-es';

import SimpleDropdown from './Dropdowns/SimpleDropdown';
import { ISODateFormat, format, today, subMonths } from '../utils/date';

const periods = ({ start, monthsCount, monthOnly, naturalOrder }) => {
  const monthOptions = times(monthsCount, (i) => {
    const prevMonth = subMonths(start, i);
    return {
      value: format(prevMonth, ISODateFormat),
      label: format(prevMonth, monthOnly ? 'MMMM' : 'MMMM YYYY'),
    };
  });

  return naturalOrder ? monthOptions.reverse() : monthOptions;
};

const MonthDropdown = ({
  current,
  start,
  disabled,
  menuAlign,
  menuWidth = 210,
  variant,
  frameless,
  caret,
  monthOnly,
  naturalOrder,
  monthsCount,
  portal,
  unselectedStateText,
  onChange,
  onMenuChange,
}) => {
  const active = format(current, ISODateFormat);

  const periodsParams = {
    start,
    monthsCount,
    monthOnly,
    naturalOrder,
  };

  return (
    <SimpleDropdown
      selected={active}
      options={periods(periodsParams)}
      caret={caret}
      variant={variant}
      frameless={frameless}
      menuAlign={menuAlign}
      menuWidth={menuWidth}
      unselectedStateText={unselectedStateText}
      portal={portal}
      disabled={disabled}
      onChange={onChange}
      onMenuChange={onMenuChange}
    />
  );
};

MonthDropdown.defaultProps = {
  start: subMonths(today(), 2),
  monthOnly: false,
  naturalOrder: false,
  monthsCount: 12,
};

MonthDropdown.propTypes = {
  current: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  unselectedStateText: PropTypes.string,
  start: PropTypes.any,
  disabled: PropTypes.bool,
  menuAlign: PropTypes.string,
  menuWidth: PropTypes.number,
  variant: PropTypes.string,
  caret: PropTypes.bool,
  frameless: PropTypes.bool,
  monthOnly: PropTypes.bool,
  naturalOrder: PropTypes.bool,
  monthsCount: PropTypes.number,
  portal: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onMenuChange: PropTypes.func,
};

export default MonthDropdown;
